/// <reference types="@angular/localize" />

import { enableProdMode, provideZoneChangeDetection } from "@angular/core";
import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";

import { AppModule } from "./app/app.module";
import { environment } from "./environments/environment";

import { licenseKey } from "./devextreme-license";
import { config } from "devextreme/common";
import dxSelectBox from 'devextreme/ui/select_box';
import dxTagBox from 'devextreme/ui/tag_box';
import { installInlineValidationErrors } from './app/helpers/inline-validation-errors';

config({ licenseKey });
dxSelectBox.defaultOptions({ options: { searchEnabled: true } });
dxTagBox.defaultOptions({ options: { searchEnabled: true } });
installInlineValidationErrors();

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()] })
  .catch((err) => console.error(err));
